import moment from 'moment-timezone';

import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import zonedMoment from 'utils/date/zonedMoment.util';
import { isTimeBefore, isTimeNotEqual } from 'utils/predicates/time/compare.util';

const COMMON_FORMAT = 'hh:mm:ss';

// DEPRECATED: use timeInRangeSimple
// SEE: src/bl/scheduler/timeInRangeSimple.bl.js
const timeInRangeOld = (bgnAp, bgnSlot, tz, slotLength) => {
  const bgnApRezoned = zonedMoment(tz, bgnAp);

  const apFormated = moment(bgnApRezoned, COMMON_FORMAT);
  const apStart = fromAnyDateToIso(
    moment(bgnApRezoned).set({
      hour: apFormated.get('hour'),
      minute: apFormated.get('minute'),
      second: 0,
      millisecond: 0,
    }),
  );

  const slotFormatted = moment(bgnSlot, COMMON_FORMAT);
  const slotStart = fromAnyDateToIso(
    moment(bgnSlot).set({
      hour: slotFormatted.get('hour'),
      minute: slotFormatted.get('minute'),
      second: 0,
      millisecond: 0,
    }),
  );

  if (isTimeNotEqual(apStart, slotStart)) return false;

  const minutes = moment.duration(slotLength, 'minutes');
  const slotEnd = fromAnyDateToIso(moment(slotStart).add(minutes));

  return isTimeBefore(apStart, slotEnd);
};

export default timeInRangeOld;
